import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=30a50f2d&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=30a50f2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a50f2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30a50f2d')) {
      api.createRecord('30a50f2d', component.options)
    } else {
      api.reload('30a50f2d', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=30a50f2d&scoped=true&", function () {
      api.rerender('30a50f2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-274dllbdX03ZA/JS/comp/DocBox.vue"
export default component.exports